import React from 'react'

import * as EmptyState from '@modules/Dashboard/components/EmptyState/EmptyState'
import { useOrdersEmptyStateRecommendations } from '@modules/Dashboard/modules/Recommendations'

export const OrdersEmptyStateWithRecommendations = () => {
  const { recommendations } = useOrdersEmptyStateRecommendations()

  return (
    <EmptyState.Root
      title="You haven’t received any orders yet"
      subtitle="Here are a few recommendations to help you get your first sales"
    >
      {recommendations && recommendations.length > 0 && (
        <EmptyState.Recommendations>
          {recommendations.map(({ suggestion, id }) => {
            return (
              <EmptyState.Suggestion key={`recommendation-${id}`} data-analytics={id}>
                {suggestion}
              </EmptyState.Suggestion>
            )
          })}
        </EmptyState.Recommendations>
      )}
    </EmptyState.Root>
  )
}
